// import React from 'react'

const messageConstant = {
  Required: 'Please enter ',
  EnterValid: 'Please enter valid ',
  SelectRequired: 'Please select ',
  TypeToSearch: 'Type to search',
  MaxFileSize: 'File size should be less than 2 MB',
  NoDataFound: 'No Data Found',
  InventoryFileExtension: 'File should be in .jpg, .png, .jpeg, or .pdf format',
  InventoryVideoExtension: 'File size should be less than 50 MB',
  ImageExtension: 'File should be in .jpg, .png, or .jpeg format',
  PDFExtension: 'Please select .PDF',
  AlreadyExists: 'already exists',
  VideoExtension: 'File should be in .mp4, .mov, .avi, .wmv or webm format',
  AlreadyExistsTitle: 'Already Exists',
  AlreadyExistsReActive:
    'alreay exists as a deleted record. To re-activate,<br /><ul><li>Go to add section</li><li>Fill the details</li><li>After clicking on save button give your confirmation to re-activate record.</li></ul>',
  AlreadyExistsAsDeleted: 'already exists as deleted record',
  AlreadyExistsAsDeletedConfirmation:
    'already exists as a deleted record. Do you want to re-activate it?',
  AllowOnlyNumber: 'Allow only number',
  OnlyTwoDecimalDigit: 'Allow only numbers with 2 decimal digit',
  CreditOrDebitGreaterThanZero: 'Please enter credit/debit amount',
  ExternalPaymentMethodSelectionRequired:
    'Please select at least one external payment configuration method',
  ImageRequired: 'Please select image',
  DeleteConfirmation: 'Are you sure you want to delete?',
  StatusActiveConfirmation: 'messageConstant.StatusActiveConfirmation',
  MarkAsPaidConfirmation: 'messageConstant.MarkAsPaidConfirmation',
  InvalidSelection: 'Invalid selection',
  PasswordValidationMessage:
    'Password requires a minimum of 4 characters, at least 1 capital, 1 lower case letter and 1 number.',
  WhiteSpaceValidationMessage: 'Whitespace not allowed in password',
  SyncronizeTitle: 'Synchronize',
  SyncronizeItems: 'Are you sure want to synchronize items?',
  ImageUploadError: 'Error occure while process please contact addministrator',

  Country: {
    IsNotMoreThan50Chanracter: 'Country name should not be more than 50 characters',
    NoSpecialCharacter: 'Please do not enter special character in country name',
    RegionNameIsNotMoreThan50Character: 'Region name should not be more than 50 characters',
    CountryCodeTwoLetter: 'Country code must contain only two letters',
  },
  State: {
    StateCodeTwoLetter: 'State code must contain only two letters',
    IsNotMoreThan50Character: 'State name should not be more than 50 characters',
  },
  EmailConfiguration: {
    AccountNameIsNotMoreThan50Char: 'Account name should not be more than 50 characters',
    EmailIsNotMoreThan50Char: 'Email address should not be more than 50 characters',
    EmailIsNotValid: 'Email address is not in valid format',
    OutgoingSMTPIsNotMoreThan50Char: 'Outgoing SMTP should not be more than 50 characters',
    ReplayToISNotMoreThan50Char: 'Reply to email should not be more than 50 characters',
    ReplayToIsNotValid: 'Reply to email is not in valid format',
    PrimaryAccountUsageMessage: 'You have selected primary account to use',
    BackupAccountUsageMessage: 'You have selected backup account to use',
  },
  Currency: {
    NameIsNotMoreThan50Char: 'Currency name should not be more than 50 characters',
    SpecialCharInCurrencyName: 'Please do not enter special character in currency name',
    CodeIsNotMoreThan50Char: 'Currency code should not be more than 50 characters',
    SymbolisNotMoreThan50Char: 'Currency symbol should not be more than 50 characters',
  },
  Qualification: {
    NameIsNotMOreThan50Char: 'Qualification name should not be more than 50 characters',
    NoSpecialCharacterinName: 'Please do not enter special character in qualification name',
  },
  Rank: {
    NameIsNotMoreThan50Char: 'Rank name should not be more than 50 characters',
    NoSpeialCharacter: 'Please do not enter special character in rank name',
  },
  Role: {
    RoleNameIsNotMoreThan50Char: 'Role name should not be more than 50 characters',
    NoSpecialCharacter: 'Please do not enter special character in role name',
  },
  LegalDocument: {
    DocumentNameLessThan50Character: 'Legal document name should not be more than 50 characters',
    NoSpecialCharacterinName: 'Please do not enter special character in document name',
  },
  Customertype: {
    TitleIsNotMoreThan50character: 'Title should not be more than 50 characters',
    NoSpecialCharInTitle: 'Please do not enter special character in title',
  },
  ItemType: {
    TitelIsNotMorethan50char: 'Title should not be more than 50 characters',
    NoSpecialCharInTitle: 'Please do not enter special character in title',
  },
  ItemCategory: {
    TitelIsNotMorethan50char: 'Title should not be more than 50 characters',
    NoSpecialCharInTitle: 'Please do not enter special character in title',
  },
  ItemAttributeConfiguration: {
    AttributeNameIsNotMorethan50char: 'Attribute name should not be more than 50 characters',
    NoSpecialCharInAttributeName: 'Please do not enter special character in attribute name',
  },
  ItemAttribute: {
    Sortorder: 'sort order',
    ItemAttributeLessThan250Char: 'Item attribute value should not be more than 250 characters',
    DoNotEnterSpecialCharInItemAttribute: 'Please do not enter special character in item attribute',
  },
  Inventory: {
    ItemLessThan100Char: 'Item name should not be more than 100 characters',
    DoNotEnterSpecialCharInItem: 'Please do not enter special character in item name',
    OnlyTwoDecimalDigit: 'Allow only numbers with 2 decimal digit',
    QuantityToAdjust: 'quantity which needs to be adjusted',
    ValidQuantity: 'Please enter valid quantity',
    KitItemAlreadyExist: 'Please select other item, this item is already selected',
    KitItemInvalid: 'Please select at least one kit item',
    KitItemNotSelected: 'Please select item',
  },
  ReoccurringBilling: {
    PriceLevel: 'price level',
    SelectPriceLevel: 'Please select price level',
    BillPeriodLessThan25Digit: 'Bill period value should not be more than 25 digits',
    DoNotEnterSpecialCharInBillPeriod: 'Please do not enter special character in bill period',
  },
  User: {
    EmailAddressIsNotMore50Char: 'Email address should not be more than 50 characters',
    EmailIsNotValid: 'Email address is not in valid format',
    PasswordIsNotMoreThan20Char: 'Password should not be more than 20 characters',
    PasswordIsNotMoreThan50Char: 'Password should not be more than 50 characters',
    PasswordDoseNotMatch: 'Password and confirm password does not match',
    FirstNameSpecialChar: 'Please do not enter any special character in first name',
    LastNameSpecialChar: 'Please do not enter any special character in last name',
    SelectState: 'Please select state for the selected country',
    ForgotPasswordSuccessResponse:
      'Password has been reset successfully. \nPlease sign-in with your new password.',
    ProfileUpdateSuccessResponse: 'Profile has been updated successfully.',
    SilentTokenAcquisitionFailed: 'Silent token acquisition fails. acquiring token using popup',
    MultipleAccountDetected: 'Multiple accounts detected.',
    ReplicationSiteNameSpecialCharacter:
      'Please do not enter white space or special character in replication site name',
    EmailAlreadyExists: 'Email address already exists',
    PrivateEmailAlreadyExists: 'Private email address already exists',
    ReplicationSiteNameAlreadyExists: 'Replication site name already exists',
    ReplicationSiteNameAvailable: 'Replication site name is available',
    PhoneNumberInvalid: 'Please enter valid phone number',
    MobileNumberInvalid: 'Please enter valid mobile number',
    ResetPasswordConfirmation: 'Are you sure you want to reset password?',
    CompanyNameWhiteSpace: 'Please do not enter white space in company name',
    PrivateEmailAndReplicationSiteNameAlreadyExists:
      'Private email address and replication site name already exists',
    ZipCodeWhiteSpace: 'Please do not enter white space in zip code',
    CityWhiteSpace: 'Please do not enter white space in city',
    ShippingAddress1WhiteSpace: 'Please do not enter white space in shipping address 1',
    ShippingZipCodeWhiteSpace: 'Please do not enter white space in shipping zip code',
    ShippingCityWhiteSpace: 'Please do not enter white space in shipping city',
    ShippingPhoneNumberInvalid: 'Please enter valid shipping phone number',
    ShippingMobileNumberInvalid: 'Please enter valid shipping mobile number',
    SaveCorporateUser: 'Corporate user details saved successfully',
    UpdateCorporateUser: 'Corporate user details updated successfully',
    UpdatePassword: 'Corporate user password updated successfully',
    SponserTextSpecialChar: 'Please do not enter any special character in sponsor search',
    SearchTextSpecialChar: 'Please do not enter white space in ',
  },
  MediaCategories: {
    nameIsNotmoreThan100Char: 'Media category name should not be more than 100 characters',
    nameIsNotContainSpecialChar: 'Please do not enter any special character in media category name',
    nameIsNotContainOnlyWhiteSpace: 'Please do not enter white space in media category name',
    descriptionISNotMoreThan100Char:
      'Media category description should not be more than 100 characters',
  },
  MediaPageConfiguration: {
    nameIsNotmoreThan100Char:
      'Media page configuration name should not be more than 100 characters',
    nameIsNotContainSpecialChar:
      'Please do not enter any special character in media page configuration name',
    nameIsNotContainOnlyWhiteSpace:
      'Please do not enter white space in media page configuration name',
  },
  MediaPage: {
    mediaPageIsNotMoreThan100Char: 'Media page should not be more than 100 characters',
    noSpecialCharInMediaPageName: 'Please do not enter any special character in media page name',
    mediaTitleIsNotMoreThan100Char: 'Page title should not be more than 100 characters',
    noSpecialCharInMediaPageTitle: 'Please do not enter any special character in media title',
    startExpirationDateCompare: 'Expiration date should be greater than start date',
  },
  PaymentMethod: {
    NameIsNotMoreThan100Char: 'Payment method name should not be more than 100 characters',
    NoSpeialCharacter: 'Please do not enter special character in payment method name',
  },
  CommissionType: {
    NameIsNotMoreThan50Char: 'Commission name should not be more than 50 characters',
    NoSpeialCharacter: 'Please do not enter special character in commission name',
  },
  Point: {
    RefLessThan50Char: 'Ref should not be more than 50 characters',
    NoNegativeNumber: 'Please do not enter negative number in order id',
  },
  iWallet: {
    RefIsNotMoreThan50Char: 'Ref should not be more than 50 characters',
    DescriptionISNotMoreThan255Char: 'iWallet description should not be more than 255 characters',
    NoSpecialCharacter: 'Please do not enter special character in withdraw method',
    WithdrawMethodIsNotMoreThan50Char: 'Withdraw method should not be more than 50 characters',
    NoNegativeNumber: 'Please do not enter negative number in',
    FilterTransactionDate: 'Please select transaction date',
  },
  ShippingMethod: {
    NameIsNotMoreThan50Char: 'Shipping method name should not be more than 50 characters',
    NoSpeialCharacter: 'Please do not enter special character in shipping method name',
  },
  Order: {
    BillingFirstNameIsNotMorethan50char: 'Billing first name is not more than 50 character',
    NoSpecialCharInBillingFirstName: 'Please do not enter special character in billing first name',
    BillingLastNameIsNotMorethan50char: 'Billing last name is not more than 50 character',
    NoSpecialCharInBillingLastName: 'Please do not enter special character in billing last name',
    ShippingFirstNameIsNotMorethan50char: 'Shipping first name is not more than 50 character',
    NoSpecialCharInShippingFirstName:
      'Please do not enter special character in shipping first name',
    ShippingLastNameIsNotMorethan50char: 'Shipping last name is not more than 50 character',
    NoSpecialCharInShippingLastName: 'Please do not enter special character in shipping last name',
    CityIsNotMorethan50char: 'City name is not more than 50 character',
    NoSpecialCharInCity: 'Please do not enter special character in city name',
    SelectOrderStatus: 'Select status',
    PercentageIsNotMoreThank100: 'Please do not enter percentage more than 100%',
    CancelOrderConfirmationMessage: 'Are you sure you want to cancel this order?',
    RefundOrderConfirmationMessage: 'Are you sure you want to refund this order?',
    CancelOrderRequired: 'Order cancel note is required',
    RefundOrderRequired: 'Order refund note is required',
    DiscardOrderConfirmationMessage: 'Are you sure you want to discard this order?',
    RecalculationCommissionSpecialChar: 'Please do not enter any special character in pin number',
  },
  OrderItem: {
    ValidQuantity: 'Please enter valid quantity',
    OrderItemAlreadyExist: 'Please select other item, this item is already in cart',
    OrderItemInvalid: 'Please select at least one order item',
    OrderAmountAndPaymentAmountMatch: 'Order item total and order payment amount does not match',
    OrderAmountAndPaymentPaidAmountMatch:
      'Order item total and order payment paid amount does not match',
    OrderPaymentMethodNotSelected: 'Please select payment method',
    OrderItemNotSelected: 'Please select item',
    InvalidDataForPayment: 'Invalid payment data for Id',
    OrderPaymentMethodAlreayExist:
      'Please select other payment method, this method is already in cart',
  },
  OrderPayment: {
    InvalidData: 'Please enter valid payment details for Id ',
  },
  FeeConfiguration: {
    FeeTitelIsNotMorethan50char: 'Fee title should not be more than 50 characters',
    DescriptionIsNotMorethan500char: 'Description should not be more than 500 characters',
  },
  TransactionMerchant: {
    CompanyNameIsNotMoreThan50Char: 'Company name should not more than 50 character',
    NoSpeialCharacterInCompanyName: 'Please do not enter special character in comapny name',
  },
  eWalletConfiguration: {
    SelectAccountType: 'Select account type',
    SelectExternalPaymentApproval: 'Select external payment approval',
    ConfigurationURLIsNotMore50Char: 'Configuration URL should not be more than 50 characters',
    ConfigurationURLIsNotValid: 'Configuration URL is not in valid format',
  },
  GiftCard: {
    GiftCardNameIsNotMoreThan100Char: 'Gift card name should not be more than 100 characters',
    AmountToAdjust: 'Please enter adjustment amount',
  },
  EmailTemplate: {
    TemplateNameIsNotMore100Char: 'Template name should not be more than 100 characters',
    SendGridTemplateIdIsNotMore100Char:
      'Send grid template id should not be more than 100 characters',
    FromEmailIsNotValid: 'From email is not in valid format',
  },
  PromoAction: {
    ActionNameIsNotMore50Char: 'Promotion action name should not be more than 50 characters',
  },
  PromoEvent: {
    PromotionNameIsNotMore100Char: 'Promotion event name should not be more than 50 characters',
  },
  Promotion: {
    IsNotMoreThan100Chanracter: 'Promotion name should not be more than 100 characters',
    startEndDateCompare: 'End date should be greater than start date',
  },
  MembershipInvoice: {
    SelectMembershipInvoiceStatus: 'Please select membership invoice status',
    InvalidMembershipItem: 'Please add valid membership item',
    InvalidNextProcessDate: 'Please select next process date greater than invoice date',
  },
  Customer: {
    SaveCustomer: 'User details saved successfully',
    UpdateCustomer: 'User details updated successfully',
    UpdatePassword: 'User password updated successfully',
  },
  PendingToActiveBonus: {
    NoRecord: 'No any record found to active bonus',
  },
  ItemIngredient: {
    IngredientNameIsNotMoreThan256character:
      'Ingredient name should not be more than 256 characters',
  },
  ImageType: {
    ImageExtension:
      'File should be in .jpg, .png, or .jpeg format are valid for selected file type',
    PDFExtension: 'File should be in .pdf format are valid for selected file type',
    VideoExtension:
      'File should be in .mp4, .mov, .avi, .wmv or webm format are valid for selected file type',
  },
  VideoType: {
    NormalVideo: 'Cannot upload a Normal Video when a YouTube/Vimeo link is provided.',
    YoutubeVideo: 'Cannot upload a YouTube/Vimeo video when a Normal Video is provided.',
    ExistingVideo: 'Either Normal Video or Youtube/vimeo can Upload',
  },
  ItemFeature: {
    FeatureNameIsNotMoreThan256character: 'Feature name should not be more than 256 characters',
    IconclassNameIsNotMoreThan256character:
      'Icon class name should not be more than 256 characters',
  },
  ResendEmailConfirmation: 'Are you sure want to resend mail?',

  Language: {
    NameIsNotMoreThan25Char: 'Language name should not be more than 25 characters',
    SpecialCharInLanguageName: 'Please do not enter special character in language name',
    CodeIsNotMoreThan2Char: 'Language code should not be more than 2 characters',
  },
  UniLevelCommission: {
    PercentageValidationMessage: 'Enter valid percentage between 0 to 100 up to 2 decmials',
  },
  MembershipARBConfiguration: {
    NoNegativeNumber:
      'MembershipARBConfiguration.Please do not enter negative number in max attempts',
    NoNegativeNumberInDayInBetweenAttempts:
      'MembershipARBConfiguration.Please do not enter negative number in days in between attempts',
  },
  InvoiceRunConfirmation: 'Are you sure want to process invoices?',
  BackOfficeMenu: {
    MediaPageSelectionRequired: 'Please select media page',
    CollapseMenuValidation: 'Please do not select parent menu when menu type is collapse',
  },
  RestrictedSubDomain: {
    SubDomainNameIsNotMoreThan50character: 'Sub-domain name should not be more than 50 characters',
  },
  ProductCredit: {
    NoNegativeNumber: 'Please do not enter negative number in',
  },
  Report: {
    EndDateGraterThan: 'End date should be greater than start date',
  },
  iWallet1099: {
    AdminOverrideCode: 'Please enter valid admin override code.',
  },
  Payment: {
    PaymentAmountDoesNotMatched: 'All Payment total is not matched with total amount',
    PaymentFormTitle: 'Add Card Details',
    SubmitFormTitle: 'Add Details',
    AddPaymentButtonTitle: 'Add Payment Details',
  },
  CommitConfirmation:
    'Are you sure want to commit commission for the given period? Selecting Yes will credit the amount to iwallet of the respective accounts.',
  UpdateRankConfirmation:
    'Are you sure you want to run the Rank Update process? This action may take some time. You will be redirected to the home page. Please revisit this page later to confirm that the process has been completed.',
  RankCalculationConfirmation:
    'Are you sure you want to run the Rank Calculation process? This action may take some time. You will be redirected to the home page. Please revisit this page later to confirm that the process has been completed.',
  PanelConfiguration: {
    ReportingAccountIdNotMoreThan10Digit:
      'Reporting Account Id value should not be more than 10 digits',
    DoNotEnterSpecialCharInReportingAccountId:
      'Please do not enter special character in Reporting Account Id',
    DoNotEnterSpecialCharInReportingIPAddress: 'Please enter valid reporting IP address',
    ReportingPortNotMoreThan2Digit: 'Reporting port value should not be more than 2 digits',
    DoNotEnterSpecialCharInReportingPort: 'Please do not enter special character in reporting port',
  },
   CheckOutPayment: {
    AddPaymentButtonTitle: 'Add Payment Details',
    AddPaymentProfileButtonTitleText: 'Add Card Details'
  }
}
export default messageConstant
